import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import ReserveRequest from "../../magData/Flight/ReserveRequest";
import ReserveResponse from "../../magData/Flight/ReserveResponse";

function FlightReservePage() {

    return (
        <>

            <Container fluid >
                <Row>
                    <Col sm={12} >
                        <p className="page-title">Flight Reserve Method</p>
                    </Col>
                    <Col sm={12} >
                        <p>EndPoint : https://gdscpapi.parsgds.com/gateway/flight/reserve</p>
                    </Col>
                    <Col sm={12} >
                        <p> type : json (default)</p>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} >
                        <p>Body Parameters</p>
                    </Col>
                    <Col sm={12} >

                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Type</th>
                                    <th>Additional information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>searchKey</td>
                                    <td>Search Key</td>
                                    <td>Guid </td>
                                    <td><Badge bg="warning" text="dark">
                                        Required
                                    </Badge></td>
                                </tr>
                                <tr>
                                    <td>gdsRefrenceID</td>
                                    <td>Refrence ID</td>
                                    <td>Guid </td>
                                    <td><Badge bg="warning" text="dark">
                                        Required
                                    </Badge></td>
                                </tr>
                                <tr>
                                    <td>travelerInfo</td>
                                    <td>Traveler Info</td>
                                    <td>Collection</td>
                                    <td></td>
                                </tr>
                                <tr >
                                    <td colSpan={4}> <Table bordered>
                                        <tbody>
                                            <tr>
                                                <td>phoneNumber</td>
                                                <td>Phone Number (0-9)</td>
                                                <td>string</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>mobile</td>
                                                <td>Mobile Number</td>
                                                <td>string</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>email</td>
                                                <td>Email Address</td>
                                                <td>string</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>airTravelers</td>
                                                <td>Air Travelers</td>
                                                <td>Collection</td>
                                                <td></td>
                                            </tr>
                                            <tr >
                                                <td colSpan={4}> <Table bordered>
                                                    <tbody>
                                                        <tr>
                                                            <td>dateOfBirth</td>
                                                            <td>Passenger Date of Birth</td>
                                                            <td>date </td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td>gender</td>
                                                            <td>Gender</td>
                                                            <td>integer</td>
                                                            <td><p>1 : Male</p><p>2 : Female</p></td>
                                                        </tr>
                                                        <tr>
                                                            <td>passengerType</td>
                                                            <td>Passenger Type</td>
                                                            <td>integer </td>
                                                            <td><p>1 : Adult</p><p>2 : Child</p><p>3 : Infant</p></td>
                                                        </tr>
                                                        <tr>
                                                            <td>passengerName</td>
                                                            <td>Passenger Name</td>
                                                            <td>object </td>
                                                            <td></td>
                                                        </tr>
                                                        <tr >
                                                            <td colSpan={4}> <Table bordered>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>passengerFirstName</td>
                                                                        <td>Passenger First name</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>passengerMiddleName</td>
                                                                        <td>Passenger middle name</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>passengerLastName</td>
                                                                        <td>Passenger last name</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>passengerTitle</td>
                                                                        <td>Passenger Title</td>
                                                                        <td>integer </td>
                                                                        <td><p>0 : Mr</p><p>1 : Mrs</p>
                                                                         <p>2 : Ms</p><p>3 : Miss</p><p>4 : Mstr</p></td>
                                                                    </tr>
                                                                </tbody></Table></td>

                                                        </tr>
                                                        <tr>
                                                            <td>passport</td>
                                                            <td>Passport information (if IsPassportMandatory is true you must provide passport expiry date)</td>
                                                            <td>obejct</td>
                                                            <td></td>
                                                        </tr>
                                                        <tr >
                                                            <td colSpan={4}> <Table bordered>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>country</td>
                                                                        <td>Country 2 letter Code</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>expiryDate</td>
                                                                        <td>Expiry Date of passport</td>
                                                                        <td>date </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>passportNumber</td>
                                                                        <td>Passport Number</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    
                                                                </tbody></Table></td>

                                                        </tr>
                                                        <tr>
                                                                        <td>nationalId</td>
                                                                        <td>ID Number</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>nationality</td>
                                                                        <td>Country 2 letter Code</td>
                                                                        <td>string </td>
                                                                        <td></td>
                                                                    </tr>
                                                    </tbody></Table></td>

                                            </tr>
                                        </tbody></Table></td>

                                </tr>
                            </tbody>
                        </Table>
                    </Col>

                </Row>
                <Row>
                    <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
                    <Col sm={12}>

                        <pre className="code-section">
                            {JSON.stringify(ReserveRequest, null, 2)}
                        </pre>


                    </Col>
                </Row>

                {/* Response  */}
                <Row>
                    <Col sm={12} >
                        <p>Response Information</p>
                    </Col>
                    <Col sm={12} >

                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Type</th>
                                    <th>Additional information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>gdsRefrenceID</td>
                                    <td>Refrence ID</td>
                                    <td>Guid </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>tktTimeLimit</td>
                                    <td>Ticket Time Limit</td>
                                    <td>date </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>priceChange</td>
                                    <td> Respond Status</td>
                                    <td>boolean </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>reserveCode</td>
                                    <td>Booking identifier Code</td>
                                    <td>string </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>adultCount</td>
                                    <td>Adult Count</td>
                                    <td>integer </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>childCount</td>
                                    <td>Child Count</td>
                                    <td>integer </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>infantCount</td>
                                    <td>Infant Count</td>
                                    <td>integer </td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>

                </Row>
                <Row>
                    <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
                    <Col sm={12}>

                        <pre className="code-section">
                            {JSON.stringify(ReserveResponse, null, 2)}
                        </pre>


                    </Col>
                </Row>
            </Container>

        </>
    );
}

export default FlightReservePage;